<script setup lang="ts">
useSeoMeta({
  title: 'Онлайн займы до 100 000 ₽ | ООО МКК «Небус» — одобрение за 10 минут',
  ogTitle: 'Онлайн займы до 100 000 ₽ | ООО МКК «Небус» — одобрение за 10 минут',
  description: 'Срочные микрозаймы с любой кредитной историей. Бесплатное оформление, перевод на карту за 5 минут. Прозрачный договор без скрытых комиссий',
})
</script>

<template>
  <div>
    <PageTitle class="md:mt-12" />
    <Calculator class="mb-8 md:mb-12" />
    <Steps />
    <Advantages hydrate-on-visible />
    <WhyClients hydrate-on-visible />
    <Howpay hydrate-on-visible />
    <Faq />
  </div>
</template>

<style>
</style>
